<div *ngIf="(!this.IsUploading && !this.HasError);else uploading">
    <p class="description">{{this.Description}}</p>

    <div mat-dialog-actions class="confirm-buttons submit-cancel-buttons ">
        <button mat-raised-button color="primary" cdkFocusInitial (click)="this.startStructureImport()">Yes</button>
        <button mat-button mat-dialog-close (click)="this.cancelClicked()">Cancel</button>
    </div>
</div>

<ng-template #uploading>
    <div *ngIf="this.IsUploading; else errored">

        <mat-progress-bar class="progress-bar-margin" mode="indeterminate"></mat-progress-bar>
        <div class="description description-margin">Importing Forms</div>

        <div class="execution-summary-div">
            <p [ngClass]="this.JobErrorOccurred ? 'execution-summary-p execution-summary-with-error-p' : 'execution-summary-p execution-summary-without-error-p'"
               data-placeholder="Details will display here ...">{{this.ExecutionSummaryText}}</p>
        </div>

    </div>
</ng-template>

<ng-template #errored>
    <div *ngIf="this.HasError">
        <p class="description">{{this.Description}}</p>

        <div mat-dialog-actions class="center-ok">
            <button mat-raised-button color="primary" cdkFocusInitial (click)="this.okClicked()">OK</button>
        </div>
    </div>
</ng-template>






